import React, { useState, useEffect, useCallback } from 'react';
import NovoProduto from './NovoProduto';

const API = process.env.REACT_APP_API_URL || '/api';
async function req(path) {
  const token = localStorage.getItem('token');
  const res = await fetch(API + path, { headers: token ? { Authorization: 'Bearer ' + token } : {} });
  return res.json();
}
async function apiPatch(path, body) {
  const token = localStorage.getItem('token');
  const res = await fetch(API + path, { method: 'PATCH', headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}) }, body: body ? JSON.stringify(body) : undefined });
  return res.json();
}
async function apiPut(path, body) {
  const token = localStorage.getItem('token');
  const res = await fetch(API + path, { method: 'PUT', headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}) }, body: JSON.stringify(body) });
  return res.json();
}
async function apiDel(path) {
  const token = localStorage.getItem('token');
  return fetch(API + path, { method: 'DELETE', headers: token ? { Authorization: 'Bearer ' + token } : {} });
}

var BADGES = { hot: 'HOT', novo: 'Novo', ultimas: 'Últimas', esgotado: 'Esgotado' };
var MKUP_MIN = 0.30;

export default function ProdutosUnificado() {
  var [products, setProducts] = useState([]);
  var [categories, setCategories] = useState([]);
  var [total, setTotal] = useState(0);
  var [loading, setLoading] = useState(true);
  var [search, setSearch] = useState('');
  var [filterCat, setFilterCat] = useState('');
  var [filterSite, setFilterSite] = useState('todos');
  var [tab, setTab] = useState('estoque');
  var [view, setView] = useState('list');

  var fetchProducts = useCallback(async function() {
    setLoading(true);
    var params = new URLSearchParams();
    if (search) params.set('search', search);
    if (filterCat) params.set('category_id', filterCat);
    var data = await req('/admin/store/products?' + params);
    setProducts(data.products || []);
    setTotal(data.total || 0);
    setLoading(false);
  }, [search, filterCat]);

  useEffect(function() { req('/admin/store/categories').then(setCategories).catch(function(){}); }, []);
  useEffect(function() { fetchProducts(); }, [fetchProducts]);

  var toggleProduct = async function(id) { await apiPatch('/admin/store/products/' + id + '/toggle'); fetchProducts(); };
  var deleteProduct = async function(id, name) { if (!window.confirm('Remover "' + name + '"?')) return; await apiDel('/admin/store/products/' + id); fetchProducts(); };
  var updateStock = async function(id, stock) { await apiPatch('/admin/store/products/' + id + '/stock', { stock: parseInt(stock) }); };
  var updatePrice = async function(id, price) {
    await apiPatch('/admin/store/products/' + id + '/quick', { price: parseFloat(price) });
    fetchProducts();
  };
  var updateCusto = async function(id, custo_unit) {
    await apiPatch('/admin/store/products/' + id + '/quick', { custo_unit: parseFloat(custo_unit) });
    fetchProducts();
  };

  var filtered = products.filter(function(p) {
    if (filterSite === 'site') return p.listar_no_site !== false;
    if (filterSite === 'interno') return p.listar_no_site === false;
    return true;
  });

  if (view === 'new' || typeof view === 'number') {
    return React.createElement(NovoProduto, {
      editId: typeof view === 'number' ? view : undefined,
      onBack: function() { setView('list'); fetchProducts(); }
    });
  }

  return React.createElement('div', { style: { padding: '1.5rem' } },
    // Header
    React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 } },
      React.createElement('h2', { style: { fontSize: '1.3rem', fontWeight: 700, color: 'var(--text-hi)' } },
        'Produtos ',
        React.createElement('span', { style: { color: 'var(--accent-2)', fontWeight: 400, fontSize: '0.9rem' } }, '(' + filtered.length + ')')
      ),
      React.createElement('div', { style: { display: 'flex', gap: 8 } },
        // Tab buttons
        React.createElement('button', { onClick: function() { setTab('estoque'); }, style: tabBtn(tab === 'estoque') }, 'Estoque'),
        React.createElement('button', { onClick: function() { setTab('margem'); }, style: tabBtn(tab === 'margem') }, 'Margem'),
        React.createElement('button', { onClick: function() { setView('new'); }, style: { padding: '8px 20px', background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: '0.82rem', cursor: 'pointer' } }, '+ Novo Produto')
      )
    ),
    // Filters
    React.createElement('div', { style: { display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' } },
      React.createElement('input', { type: 'text', placeholder: 'Buscar produto...', value: search, onChange: function(e) { setSearch(e.target.value); }, style: inputStyle }),
      React.createElement('select', { value: filterCat, onChange: function(e) { setFilterCat(e.target.value); }, style: { padding: '8px 12px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 6, color: 'var(--text-mid)', fontSize: '0.82rem' } },
        React.createElement('option', { value: '' }, 'Todas categorias'),
        categories.map(function(c) { return React.createElement('option', { key: c.id, value: c.id }, (c.icon || '') + ' ' + c.name); })
      ),
      React.createElement('div', { style: { display: 'flex', gap: 4, marginLeft: 8 } },
        ['todos', 'site', 'interno'].map(function(val) {
          var labels = { todos: 'Todos', site: 'No Site', interno: 'So Interno' };
          return React.createElement('button', { key: val, onClick: function() { setFilterSite(val); }, style: pillBtn(filterSite === val) }, labels[val]);
        })
      )
    ),
    // Table
    loading
      ? React.createElement('p', { style: { color: 'var(--text-lo)' } }, 'Carregando...')
      : tab === 'estoque' ? renderEstoque(filtered, setView, toggleProduct, deleteProduct, updateStock)
                          : renderMargem(filtered, setView, updatePrice, updateCusto)
  );
}

function renderEstoque(products, setView, toggleProduct, deleteProduct, updateStock) {
  var headers = ['', 'Produto', 'Cat.', 'Preço', 'Estoque', 'Badge', 'Site', 'Status', ''];
  return React.createElement('div', { style: { overflowX: 'auto' } },
    React.createElement('table', { style: { width: '100%', borderCollapse: 'collapse' } },
      React.createElement('thead', null,
        React.createElement('tr', { style: { borderBottom: '2px solid var(--border)' } },
          headers.map(function(h) { return React.createElement('th', { key: h, style: thStyle }, h); })
        )
      ),
      React.createElement('tbody', null,
        products.map(function(p) {
          var noSite = p.listar_no_site !== false;
          return React.createElement('tr', { key: p.id, style: { borderBottom: '1px solid var(--border)', opacity: p.active ? 1 : 0.4 } },
            // Thumb
            React.createElement('td', { style: C }, p.primary_image ? React.createElement('img', { src: p.primary_image, alt: '', style: { width: 36, height: 36, objectFit: 'contain', borderRadius: 6, background: 'var(--surface)' } }) : null),
            // Nome
            React.createElement('td', { style: Object.assign({}, C, { maxWidth: 230 }) },
              React.createElement('div', { style: { fontWeight: 600, color: 'var(--text-hi)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '0.82rem' } }, p.name),
              p.fornecedor ? React.createElement('div', { style: { fontSize: '0.65rem', color: 'var(--text-lo)' } }, p.fornecedor) : null
            ),
            // Cat
            React.createElement('td', { style: C }, React.createElement('span', { style: { fontSize: '0.7rem', padding: '2px 8px', borderRadius: 10, background: 'rgba(155,89,182,0.15)', color: '#c8a0e8' } }, p.category_name)),
            // Preco
            React.createElement('td', { style: Object.assign({}, C, { fontWeight: 700, color: 'var(--accent)' }) }, 'R$ ' + parseFloat(p.price).toFixed(2)),
            // Estoque editavel
            React.createElement('td', { style: C },
              React.createElement('input', { type: 'number', min: 0, defaultValue: p.stock, key: p.id + '-' + p.stock,
                style: { width: 60, padding: '4px 6px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 4, color: 'var(--text-hi)', fontSize: '0.82rem', textAlign: 'center' },
                onBlur: function(e) { var v = parseInt(e.target.value); if (!isNaN(v) && v !== p.stock) updateStock(p.id, v); },
                onKeyDown: function(e) { if (e.key === 'Enter') e.target.blur(); }
              })
            ),
            // Badge
            React.createElement('td', { style: C }, BADGES[p.badge] || '—'),
            // Site
            React.createElement('td', { style: C }, React.createElement('span', { style: { fontSize: '0.72rem', fontWeight: 600, color: noSite ? '#34d399' : 'var(--text-lo)' } }, noSite ? 'Sim' : 'Nao')),
            // Status
            React.createElement('td', { style: C },
              React.createElement('button', { onClick: function() { toggleProduct(p.id); },
                style: { padding: '2px 8px', borderRadius: 10, fontSize: '0.65rem', fontWeight: 700, cursor: 'pointer', border: 'none', background: p.active ? 'rgba(37,211,102,0.15)' : 'rgba(239,68,68,0.15)', color: p.active ? '#6ee7b7' : '#fca5a5' } },
                p.active ? 'Ativo' : 'Inativo')
            ),
            // Acoes
            React.createElement('td', { style: C },
              React.createElement('div', { style: { display: 'flex', gap: 6 } },
                React.createElement('button', { onClick: function() { setView(p.id); }, title: 'Editar',
                  style: { background: 'none', border: '1px solid var(--border)', borderRadius: 6, color: 'var(--text-mid)', cursor: 'pointer', padding: '4px 8px', fontSize: '0.8rem' } }, 'Ed.'),
                React.createElement('button', { onClick: function() { deleteProduct(p.id, p.name); }, title: 'Remover',
                  style: { background: 'none', border: 'none', color: 'var(--text-lo)', cursor: 'pointer', fontSize: '0.85rem', padding: '4px' } }, 'x')
              )
            )
          );
        })
      )
    ),
    !products.length ? React.createElement('p', { style: { color: 'var(--text-lo)', textAlign: 'center', padding: '2rem' } }, 'Nenhum produto') : null
  );
}

function renderMargem(products, setView, updatePrice, updateCusto) {
  var headers = ['Produto', 'Custo (R$)', 'Min 30%', 'Preço Minimo', 'Preço Final (R$)', 'Markup', ''];
  return React.createElement('div', { style: { overflowX: 'auto' } },
    React.createElement('table', { style: { width: '100%', borderCollapse: 'collapse' } },
      React.createElement('thead', null,
        React.createElement('tr', { style: { borderBottom: '2px solid var(--border)' } },
          headers.map(function(h) { return React.createElement('th', { key: h, style: thStyle }, h); })
        )
      ),
      React.createElement('tbody', null,
        products.map(function(p) {
          var custo = parseFloat(p.custo_unit || 0);
          var preco = parseFloat(p.price || 0);
          var precoMin = custo > 0 ? custo * (1 + MKUP_MIN) : 0;
          var markupFinal = custo > 0 ? ((preco - custo) / custo * 100) : null;
          var isAboveMin = custo > 0 ? preco >= precoMin : true;
          var lucro = custo > 0 ? preco - custo : 0;
          return React.createElement('tr', { key: p.id, style: { borderBottom: '1px solid var(--border)', background: custo > 0 && !isAboveMin ? 'rgba(239,68,68,0.04)' : 'transparent' } },
            // Produto
            React.createElement('td', { style: Object.assign({}, C, { fontWeight: 600, color: 'var(--text-hi)', maxWidth: 250 }) },
              React.createElement('div', { style: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, p.name)
            ),
            // Custo EDITAVEL
            React.createElement('td', { style: C },
              React.createElement('input', { type: 'number', step: '0.01', min: 0, defaultValue: custo > 0 ? custo.toFixed(2) : '', key: p.id + '-custo-' + custo,
                placeholder: '0.00',
                style: { width: 90, padding: '4px 8px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 4, color: 'var(--text-hi)', fontSize: '0.85rem', textAlign: 'right' },
                onBlur: function(e) { var v = parseFloat(e.target.value); if (!isNaN(v) && v !== custo) updateCusto(p.id, v); },
                onKeyDown: function(e) { if (e.key === 'Enter') e.target.blur(); }
              })
            ),
            // Mkup Min 30% (fixo)
            React.createElement('td', { style: Object.assign({}, C, { color: 'var(--text-lo)', textAlign: 'center' }) }, '30%'),
            // Preco Minimo (calculado, nao editavel)
            React.createElement('td', { style: Object.assign({}, C, { color: 'var(--text-lo)' }) }, custo > 0 ? 'R$ ' + precoMin.toFixed(2) : '---'),
            // Preco Final EDITAVEL
            React.createElement('td', { style: C },
              React.createElement('input', { type: 'number', step: '0.01', min: 0, defaultValue: preco > 0 ? preco.toFixed(2) : '', key: p.id + '-price-' + preco,
                placeholder: '0.00',
                style: { width: 90, padding: '4px 8px', background: 'var(--surface)', border: '1px solid ' + (custo > 0 && !isAboveMin ? '#ef4444' : 'var(--border)'), borderRadius: 4, color: 'var(--accent)', fontSize: '0.85rem', fontWeight: 700, textAlign: 'right' },
                onBlur: function(e) { var v = parseFloat(e.target.value); if (!isNaN(v) && v !== preco) updatePrice(p.id, v); },
                onKeyDown: function(e) { if (e.key === 'Enter') e.target.blur(); }
              })
            ),
            // Markup Final (calculado)
            React.createElement('td', { style: Object.assign({}, C, { fontWeight: 700, minWidth: 100 }) },
              markupFinal !== null
                ? React.createElement('div', null,
                    React.createElement('span', { style: { color: isAboveMin ? '#34d399' : '#fca5a5', fontSize: '0.9rem' } }, markupFinal.toFixed(1) + '%'),
                    React.createElement('div', { style: { fontSize: '0.65rem', color: lucro >= 0 ? '#34d399' : '#fca5a5' } }, 'R$ ' + lucro.toFixed(2))
                  )
                : React.createElement('span', { style: { color: 'var(--text-lo)' } }, '---')
            ),
            // Editar
            React.createElement('td', { style: C },
              React.createElement('button', { onClick: function() { setView(p.id); },
                style: { background: 'none', border: '1px solid var(--border)', borderRadius: 6, color: 'var(--text-mid)', cursor: 'pointer', padding: '4px 8px', fontSize: '0.8rem' } }, 'Ed.')
            )
          );
        })
      )
    ),
    !products.length ? React.createElement('p', { style: { color: 'var(--text-lo)', textAlign: 'center', padding: '2rem' } }, 'Nenhum produto') : null
  );
}

function tabBtn(active) {
  return { padding: '6px 16px', borderRadius: 8, fontSize: '0.78rem', fontWeight: 700, cursor: 'pointer', border: 'none',
    background: active ? 'var(--accent)' : 'var(--surface)', color: active ? '#fff' : 'var(--text-mid)',
    ...(active ? {} : { border: '1px solid var(--border)' }) };
}
function pillBtn(active) {
  return { padding: '6px 14px', borderRadius: 20, fontSize: '0.72rem', fontWeight: 700, cursor: 'pointer', border: active ? 'none' : '1px solid var(--border)',
    background: active ? 'var(--accent)' : 'var(--surface)', color: active ? '#fff' : 'var(--text-mid)' };
}

var C = { padding: '8px 6px', fontSize: '0.8rem', color: 'var(--text-mid)' };
var thStyle = { padding: '10px 6px', textAlign: 'left', fontSize: '0.7rem', fontWeight: 700, color: 'var(--text-lo)', textTransform: 'uppercase', letterSpacing: '0.04em' };
var inputStyle = { flex: 1, maxWidth: 280, padding: '8px 12px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 6, color: 'var(--text-hi)', fontSize: '0.85rem' };
